import type { FC } from 'react';

import { NavLink } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import { Outlet } from 'react-router-dom';
import { Button, Col, Row } from 'react-bootstrap';
import * as React from 'react';
import { useAuth } from '../Contexts/AuthProvider';
import { NavProfile, NavProfileTheme } from './Components/NavProfile';
import { useTemplate } from './Hooks/useTemplate';

export const HomeTemplate = () => {
  useTemplate('home');

  const [scrolled, setScrolled] = React.useState(false);
  const headerRef = React.useRef<HTMLElement | null>(null);

  const session = useAuth();

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <Navbar
        ref={headerRef}
        fixed="top"
        expand="lg"
        className={`py-3 ${scrolled ? 'is-scrolled' : ''}`}
      >
        <Container className="max-w-xl">
          <Navbar.Brand as={NavLink} to="/">
            <div className="logo d-inline-block align-top me-4" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="home-navbar-nav" />
          <Navbar.Collapse id="home-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={NavLink} to="/home/agents" className="px-3">
                For Agents
              </Nav.Link>
              <Nav.Link as={NavLink} to="/home/agencies" className="px-3 ms-1">
                For Agencies
              </Nav.Link>
              <Nav.Link as={NavLink} to="/home/pricing" className="px-3 ms-1">
                Pricing
              </Nav.Link>
              <Nav.Link as={NavLink} to="/home/log-in" className="px-3 ms-1">
                Log In
              </Nav.Link>
              <Nav.Link as={NavLink} to="/home/sign-up" className="px-3 ms-1">
                Sign Up
              </Nav.Link>
            </Nav>

            {session.isAuthenticated() === true && (
              <NavProfile theme={NavProfileTheme.Light} session={session} />
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <main>
        <Outlet />
      </main>
      <footer className="bg-brand">
        <Container className="pt-5 pb-5 max-w-xl">
          <Row>
            <Col xs={6} className="text-left">
              <img src="/assets/logo/logo-light.png" className="logo mb-3" />
              <p className="text-secondary small">
                © {new Date().getFullYear()} MedicarePRO | CRM. All rights reserved
                <br />
                Proudly made in AZ.
              </p>
              <p className="small mt-5">
                <NavLink className="me-3 text-secondary" to="/home/privacy" end>
                  Privacy
                </NavLink>
                <NavLink className="me-3 text-secondary" to="/home/terms" end>
                  Terms of Use
                </NavLink>
                <NavLink className="me-3 text-secondary" to="/home/version-history" end>
                  Version History
                </NavLink>
                <NavLink
                  className="me-3 text-secondary"
                  to="https://medicareprocrm1.statuspage.io/"
                >
                  System Status
                </NavLink>
                <NavLink className="me-3 text-secondary" to="/home/security" end>
                  Trust & Security
                </NavLink>
              </p>
            </Col>
            <Col xs={6} className="text-end">
              <h4 className="text-secondary">Got questions?</h4>
              <Button className="btn btn-primary mt-3 mb-4">Contact Us</Button>
              <div>
                <img src="/assets/home/hippa.png" />
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};
